let SWHeartBeat = null;

export const registerSW = async () => {
	if (!navigator || !navigator.serviceWorker) {
		console.log('Service workers are not supported in this browser.');
		return;
	}

	return navigator.serviceWorker.register('sw.js', {
		scope: './',
	}).then((registration) => {
		return registration.update();
	}).then((registration) => {
		if (registration.installing) {
			console.log('Service worker installing');
		} else if (registration.waiting) {
			console.log('Service worker installed');
			// Force the waiting service worker to become active
			registration.waiting.postMessage({ type: 'skipWaiting' });
		} else if (registration.active) {
			console.log('Service worker active');
			// Check if the service worker is also the controller
			if (navigator && navigator.serviceWorker && navigator.serviceWorker.controller) {
				console.log('Service worker is controlling the page');
			} else {
				console.log('Service worker is active but not yet controlling this page');
				// Try to claim clients immediately for faster controller availability
				registration.active.postMessage({ type: 'claimClients' });
			}
		}
		
		// Return the registration for further use
		return registration;
	}).catch((error) => {
		console.error(`Registration failed with ${error}`);
	});
};

const messageListener = () => {
	clearTimeout(SWHeartBeat);
	SWHeartBeat = setTimeout(() => {
		console.log('trying to reactivate the service worker');
		registerSW();
	}, 5 * 60 * 1000);
};

export const listenToSW = () => {
	if (!navigator || !navigator.serviceWorker) {
		return;
	}

	navigator.serviceWorker.removeEventListener('message', messageListener);
	navigator.serviceWorker.addEventListener('message', messageListener);

	// Reload when a new service worker takes control (app update deployed)
	const hadController = !!navigator.serviceWorker.controller;
	navigator.serviceWorker.addEventListener('controllerchange', () => {
		if (hadController) {
			const lastReload = sessionStorage.getItem('lastAppReload');
			if (lastReload && Date.now() - Number(lastReload) < 60000) {
				return;
			}
			console.log('New service worker took control — reloading for app update');
			sessionStorage.setItem('lastAppReload', String(Date.now()));
			window.location.reload();
		} else {
			console.log('Initial service worker claim — no reload needed');
		}
	});
};

export const closeListenerToSw = () => {
    clearTimeout(SWHeartBeat);
};

export const deleteFromCache = (urls) => {
	if (!navigator || !navigator.serviceWorker || !navigator.serviceWorker.controller) {
		return;
	}

	let data = urls;
	if (!Array.isArray(urls)) {
		data = [urls];
	}

	return navigator.serviceWorker.controller.postMessage({
		type: 'deleteFromCache',
		data,
	});
};

export const preCache = (assets, cb) => {
	// Make this date + random to ensure uniqueness
	const operationID = Date.now() + Math.floor(Math.random() * 1000);
	if (!navigator || !navigator.serviceWorker || !navigator.serviceWorker.controller) {
		return;
	}

	let data = assets;
	if (!Array.isArray(assets)) {
		data = [assets];
	}

	navigator.serviceWorker.controller.postMessage({
		type: 'preCache',
		data,
		operationID,
	});

	if (typeof cb === 'function') {
		const dynamicCB = (res) => {
			if (res.data && res.data.msg === 'precache complete' &&
				res.data && res.data.operationID === operationID &&
				res.data && res.data.success) {
				cb(operationID);
				navigator.serviceWorker.removeEventListener('message', dynamicCB);
			}
		};
		navigator.serviceWorker.addEventListener('message', dynamicCB);
	}

	return operationID;
};